import { render, staticRenderFns } from "./MagicLinkModal.vue?vue&type=template&id=45666fee&scoped=true"
import script from "./MagicLinkModal.vue?vue&type=script&lang=ts"
export * from "./MagicLinkModal.vue?vue&type=script&lang=ts"
import style0 from "./MagicLinkModal.vue?vue&type=style&index=0&id=45666fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45666fee",
  null
  
)

export default component.exports